import React, { useEffect, useRef } from "react";
import { Html5Qrcode } from "html5-qrcode";
import { X } from "lucide-react";

export default function QrScanner({ onScan, onClose }) {
  const scannerRef = useRef(null);
  const readerId = "qr-reader-box";

  useEffect(() => {
    let scanner;
    const start = async () => {
      try {
        scanner = new Html5Qrcode(readerId);
        scannerRef.current = scanner;
        await scanner.start(
          { facingMode: "environment" },
          { fps: 10, qrbox: { width: 240, height: 240 } },
          (decoded) => {
            onScan(decoded);
            stop();
          },
          () => {}
        );
      } catch (e) {
        console.error("QR start failed", e);
      }
    };
    const stop = async () => {
      try {
        if (scannerRef.current && scannerRef.current.isScanning) {
          await scannerRef.current.stop();
          await scannerRef.current.clear();
        }
      } catch {}
    };
    start();
    return () => { stop(); };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="fixed inset-0 z-[60] bg-slate-900/70 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full">
        <div className="px-5 py-3 border-b border-[#E5E7EB] flex items-center justify-between">
          <h4 className="font-medium">Scan Roll QR / Barcode</h4>
          <button onClick={onClose} data-testid="qr-close" className="text-[#64748B] hover:text-slate-900"><X size={18} /></button>
        </div>
        <div className="p-4">
          <div id={readerId} className="w-full aspect-square rounded-md bg-black overflow-hidden" />
          <div className="text-[11px] text-[#64748B] mt-2 text-center">
            Point your camera at the roll's QR code or barcode. Grant camera permission if prompted.
          </div>
        </div>
      </div>
    </div>
  );
}
